export default __webpack_public_path__ + "static/sparkle-business-vas-banner-7b9904b8d30fd420a51e2e1beca8511a.png";